import { Link } from "react-router-dom";

const LOGO_URL =
  "https://dcdws.blob.core.windows.net/dws-19661937-81179-media/sites/81179/2024/12/united-auto1-w300.png";

const internalLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About Us", to: "/about" },
  { label: "Location", to: "/location" },
];

const externalLinks = [
  { label: "Browse Inventory", href: "https://www.uagmn.com/inventory/" },
  { label: "Apply for Financing", href: "https://www.uagmn.com/apply-online/" },
  { label: "Get Pre-Qualified", href: "https://www.uagmn.com/get-pre-qualified/" },
  { label: "Car Finder", href: "https://www.uagmn.com/car-finder/" },
  { label: "Warranty Info", href: "https://www.uagmn.com/warranty/" },
  { label: "Testimonials", href: "https://www.uagmn.com/testimonials/" },
];

const serviceAreas = [
  "Farmington, MN",
  "Apple Valley, MN",
  "Lakeville, MN",
  "Burnsville, MN",
  "Eagan, MN",
  "Rosemount, MN",
  "Prior Lake, MN",
  "Savage, MN",
  "Hastings, MN",
  "Northfield, MN",
];

export default function Footer() {
  return (
    <footer className="bg-[#16120D] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="United Auto Group"
              className="h-10 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-sm text-white/60 leading-relaxed mb-5">
              Farmington&apos;s trusted used car dealership. Quality pre-owned
              vehicles, flexible financing, and exceptional service since day
              one.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="tel:(952)769-3208"
                className="flex items-center gap-2 text-sm text-white/80 hover:text-gold-DEFAULT transition-colors cursor-pointer whitespace-nowrap"
                aria-label="Call (952) 769-3208"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-gold-DEFAULT text-sm" />
                </div>
                (952) 769-3208
              </a>
              <a
                href="mailto:info@uagmn.com"
                className="flex items-center gap-2 text-sm text-white/80 hover:text-gold-DEFAULT transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-fill text-gold-DEFAULT text-sm" />
                </div>
                info@uagmn.com
              </a>
              <a
                href="https://maps.app.goo.gl/Vm3ubU5UPaCURLk67"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 text-sm text-white/80 hover:text-gold-DEFAULT transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-fill text-gold-DEFAULT text-sm" />
                </div>
                1024 8th St, Farmington, MN 55024
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase text-gold-DEFAULT mb-5">
              <a id="footer-nav" href="#">Navigation</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {internalLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              {externalLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    rel="noopener noreferrer"
                    className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase text-gold-DEFAULT mb-5">
              <a id="footer-areas" href="#">Service Areas</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {serviceAreas.map((area) => (
                <li key={area}>
                  <span className="text-sm text-white/70">{area}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours + Trust */}
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase text-gold-DEFAULT mb-5">
              <a id="footer-hours" href="#">Business Hours</a>
            </h4>
            <ul className="flex flex-col gap-2 mb-6">
              <li className="text-sm text-white/70 flex justify-between whitespace-nowrap gap-4">
                <span>Mon – Fri</span>
                <span className="text-white/90">9:00 AM – 6:00 PM</span>
              </li>
              <li className="text-sm text-white/70 flex justify-between whitespace-nowrap gap-4">
                <span>Saturday</span>
                <span className="text-white/90">9:00 AM – 5:00 PM</span>
              </li>
              <li className="text-sm text-white/70 flex justify-between whitespace-nowrap gap-4">
                <span>Sunday</span>
                <span className="text-white/90">Closed</span>
              </li>
            </ul>
            <div className="border border-gold-DEFAULT/30 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                {[1, 2, 3, 4, 5].map((s) => (
                  <div key={s} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-gold-DEFAULT text-xs" />
                  </div>
                ))}
                <span className="text-white/80 text-sm ml-1">5.0 Rating</span>
              </div>
              <p className="text-xs text-white/60">
                47+ verified Google reviews. All Credit Types Welcome.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © 2026 United Auto Group — 1024 8th St, Farmington, MN 55024. All
            Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.uagmn.com/privacy-policy/"
              rel="noopener noreferrer"
              className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy Policy
            </a>
            <span className="text-white/20">|</span>
            <a
              href="mailto:info@uagmn.com"
              className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap"
            >
              info@uagmn.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
